import { ZipCodeFilterState } from '../../FilterStore'
import { FilterChipCloseButton, FilterChipContainer } from './FilterChipStyles'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

export type FilterZipRangeProps = {
  label: string
  active: ZipCodeFilterState
  onClose?: () => void
  isExclusive: boolean
  isHovered?: boolean
}

export function FilterChipZipRange({
  label,
  active,
  onClose,
  isExclusive,
  isHovered,
}: FilterZipRangeProps) {
  const variant = useTableLinkVariant()
  const isPlain = variant === 'plain'
  const getFormattedValue = () => {
    const zips = active?.[0] ?? []
    const range = active?.[1]
    const zipLabel = zips.join(', ')
    if (range != null) {
      return `${zipLabel} (${range} mile${range > 1 ? 's' : ''})`
    }
    return zipLabel
  }

  return (
    <FilterChipContainer
      $isExclusive={isPlain ? false : isExclusive}
      isHovered={isHovered}
    >
      <span>
        {`${label}: `}
        {isPlain && isExclusive ? <b>NOT </b> : null}
        <b>{getFormattedValue()}</b>
      </span>
      {onClose && (
        <FilterChipCloseButton
          $isExclusive={isPlain ? false : isExclusive}
          onClick={onClose}
        />
      )}
    </FilterChipContainer>
  )
}
